import { baseRoutes } from '@routes/helpers/baseRoutes.ts';
import { routesPaths } from '@routes/helpers/constants.ts';
import { AppRouteConfig } from '@routes/route';

export const accountsRoutes: ReadonlyArray<AppRouteConfig> = [
  {
    path: baseRoutes.accounts.root,
    lazyImport: () => import('../../domains/protected/accounts/AccountsRoute.tsx'),
    requiresAuth: true,
    resourceId: 'entity',
    children: [
      {
        index: true,
        redirectTo: routesPaths.accounts.entities.root
      },
      {
        path: baseRoutes.accounts.entities.root,
        lazyImport: () => import('../../domains/protected/accounts/shared/ListEntities.tsx'),
        nav: {
          hideBack: true,
          breadcrumbKey: 'list'
        }
      },
      {
        path: baseRoutes.accounts.entities.new,
        lazyImport: () =>
          import('../../domains/protected/accounts/pages/entities/entity-details/EntityDetailsRoute.tsx'),
        nav: {
          backTo: routesPaths.accounts.root,
          breadcrumbKey: 'new'
        }
      },
      {
        path: baseRoutes.accounts.entities.details,
        lazyImport: () =>
          import('../../domains/protected/accounts/pages/entities/entity-details/EntityDetailsRoute.tsx'),
        nav: {
          backTo: routesPaths.accounts.root,
          breadcrumbKey: 'details'
        }
      },
      {
        path: baseRoutes.accounts.groupEntities.root,
        resourceId: 'group-entity',
        lazyImport: () => import('../../domains/protected/accounts/shared/ListEntities.tsx'),
        nav: {
          hideBack: true,
          breadcrumbKey: 'list'
        }
      },
      {
        path: baseRoutes.accounts.groupEntities.new,
        lazyImport: () =>
          import('../../domains/protected/accounts/pages/group-entities/group-entity-details/GroupEntityDetailsRoute.tsx'),
        resourceId: 'group-entity',
        nav: {
          backTo: routesPaths.accounts.groupEntities.root,
          breadcrumbKey: 'new'
        }
      },
      {
        path: baseRoutes.accounts.groupEntities.details,
        lazyImport: () =>
          import('../../domains/protected/accounts/pages/group-entities/group-entity-details/GroupEntityDetailsRoute.tsx'),
        resourceId: 'group-entity',
        nav: {
          backTo: routesPaths.accounts.groupEntities.root,
          breadcrumbKey: 'details'
        }
      },
      {
        path: baseRoutes.accounts.dataPools.root,
        lazyImport: () =>
          import('../../domains/protected/accounts/pages/datapools/datapools-list/DatapoolsListRoute.tsx'),
        nav: {
          hideBack: true,
          breadcrumbKey: 'list'
        }
      },
      {
        path: baseRoutes.accounts.dataPools.new,
        lazyImport: () =>
          import('../../domains/protected/accounts/pages/datapools/datapool-details/DatapoolDetailsRoute.tsx'),
        resourceId: 'entity',
        nav: {
          backTo: routesPaths.accounts.dataPools.root,
          breadcrumbKey: 'new'
        }
      },
      {
        path: baseRoutes.accounts.dataPools.details,
        lazyImport: () =>
          import('../../domains/protected/accounts/pages/datapools/datapool-details/DatapoolDetailsRoute.tsx'),
        resourceId: 'entity',
        nav: {
          backTo: routesPaths.accounts.dataPools.root,
          breadcrumbKey: 'details'
        }
      },
      {
        path: baseRoutes.accounts.tags,
        lazyImport: () =>
          import('../../domains/protected/accounts/pages/tags/tags-list/TagsListRoute.tsx'),
        nav: {
          hideBack: true,
          breadcrumbKey: 'list'
        }
      },
      {
        path: '*',
        redirectTo: baseRoutes.accounts.root
      }
    ]
  }
];
